module.exports = __webpack_public_path__ + "img/ring_g_l_0_1.536a639e.png";